// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

sf-footer {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
}

sf-footer > span {
  font-family: sans-serif;
  font-size: 14px;
  /* don't wrap, show ellipsis */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /* show ellipsis on the left hand side */
  /* in combination with &lrm; entity prepended and appended to text */
  direction: rtl;
}

/* prepend &lrm; entity to text to avoid re-ordering of text */
sf-footer > span::before {
  content: "\\200E";
}

/* append &lrm; entity to text to avoid re-ordering of text*/
sf-footer > span::after {
  content: "\\200E";
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;EACxC,oEAAoE;EACpE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;AAClB","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\nsf-footer {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: right;\n}\n\nsf-footer > span {\n  font-family: sans-serif;\n  font-size: 14px;\n  /* don't wrap, show ellipsis */\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  /* show ellipsis on the left hand side */\n  /* in combination with &lrm; entity prepended and appended to text */\n  direction: rtl;\n}\n\n/* prepend &lrm; entity to text to avoid re-ordering of text */\nsf-footer > span::before {\n  content: \"\\200E\";\n}\n\n/* append &lrm; entity to text to avoid re-ordering of text*/\nsf-footer > span::after {\n  content: \"\\200E\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
